<template>
  <div class="score">
    <button class="remove" @click="remove"><i class="el-icon-delete" title="Supprimer"/></button>
    <competitor-detail type="status" parent="Score" :parentId="score.id" :id="score.statusId"/>
    <input class="order" type="text" title="Ordre du score" :value="score.order" @change="changeOrder"/>
    <div>
      <span>{{ type.name }} </span>
      <input class="score" type="text" title="Valeur du score" :value="score.score" @change="changeScore" v-if="!time"/>
      <input ref="hour" class="hour" type="text" title="Heures" :value="hour" @change="changeHour" v-if="time"/>
      <input ref="minute" class="minute" type="text" title="Minutes du score" :value="minute" @change="changeMinute" v-if="time"/>
      <input ref="seconde" class="seconde" type="text" title="Secondes" :value="seconde" @change="changeSeconde" v-if="time"/>
      <input ref="milliseconde" class="milliseconde" type="text" title="Millisecondes" :value="milliseconde" @change="changeMilliseconde" v-if="time"/>
    </div>
  </div>
</template>

<script>
import CompetitorDetail from '@/components/sport/games/CompetitorDetail'

export default {
  name: 'SportScore',
  components: { CompetitorDetail },
  props: {
    scoreTypes: Array,
    score: Object
  },
  data () {
    return {
      open: false
    }
  },
  computed: {
    type () { return this.score.getType() },
    unit () { return this.type.getUnit() },
    time () { return this.unit.time },
    hour () { return this.time === true ? Math.trunc(this.score.score / (60 * 60 * 1000)) : '' },
    minute () { return this.time === true ? Math.trunc(this.score.score / (60 * 1000)) - this.hour * 60 : '' },
    seconde () { return this.time === true ? Math.trunc(this.score.score / 1000) - this.hour * (60 * 60) - this.minute * 60 : '' },
    milliseconde () { return this.time === true ? (this.score.score % 1000) : '' }
  },
  methods: {
    changeType (event) { this.$store.dispatch('Sport/Score/put', { id: this.score.id, typeId: event.target.value }) },
    changeOrder (event) { this.$store.dispatch('Sport/Score/put', { id: this.score.id, order: event.target.value }) },
    changeScore (event) { this.$store.dispatch('Sport/Score/put', { id: this.score.id, score: event.target.value }) },
    changeHour (event) { this.changeTime(parseInt(event.target.value), parseInt(this.$refs.minute.value), parseInt(this.$refs.seconde.value), parseInt(this.$refs.milliseconde.value)) },
    changeMinute (event) { this.changeTime(parseInt(this.$refs.hour.value), parseInt(event.target.value), parseInt(this.$refs.seconde.value), parseInt(this.$refs.milliseconde.value)) },
    changeSeconde (event) { this.changeTime(parseInt(this.$refs.hour.value), parseInt(this.$refs.minute.value), parseInt(event.target.value), parseInt(this.$refs.milliseconde.value)) },
    changeMilliseconde (event) { this.changeTime(parseInt(this.$refs.hour.value), parseInt(this.$refs.minute.value), parseInt(this.$refs.seconde.value), parseInt(event.target.value)) },
    changeTime (hours, minutes, secondes, millisecondes) {
      const value = (hours * (60 * 60 * 1000)) + (minutes * (60 * 1000)) + (secondes * 1000) + millisecondes
      this.$store.dispatch('Sport/Score/put', { id: this.score.id, score: value })
    },
    remove () {
      this.$store.dispatch('Sport/Score/delete', this.score.id)
    }
  }
}
</script>

<style scoped>
  .score{
    display:flex;
    align-items:center
  }
  .score > button.remove{
    margin-right:5px
  }
  .score > button > i{
    color:red
  }
  .score > div {
    display:flex
  }
  .score > div > span{
    font-size:.75em;
    margin-right:5px;
  }
  .score input{
    text-align:right;
    border-radius:4px;
    border:1px solid #aaa
  }
  .score > input.order{
    width:20px;
    margin-left:5px;
    background-color:#eee
  }
  .score > div{
    margin-left:5px
  }
  .score > div > input.score{
    width:40px
  }
  .score > div > input.hour{
    width:20px;
  }
  .score > div > input.minute,
  .score > div > input.seconde{
    width:20px;
    margin-left:1px
  }
  .score > div > input.milliseconde{
    width:30px;
    margin-left:1px
  }
</style>
